import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/shared/store/auth'
import type { ReactNode } from 'react'

interface RequireAuthProps {
  children: ReactNode
}

export function RequireAuth({ children }: RequireAuthProps) {
  const user = useAuthStore((s) => s.user)
  const role = useAuthStore((s) => s.role)
  const location = useLocation()

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  if (!role) {
    return <Navigate to="/select-role" replace />
  }
  return <>{children}</>
}

export function RedirectIfAuthed({ children }: RequireAuthProps) {
  const user = useAuthStore((s) => s.user)
  const role = useAuthStore((s) => s.role)
  if (user && role) {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}
